import { Validators } from '@angular/forms';

export class CarLoanDetailsModel {
  carLoanProduct = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  carLoanPurpose = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  carType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  carLoanAmtIncGst = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  carLoanDeposit = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  carLoanSubtotal = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanApplicationFee = {
    value: 400,
    validation: Validators.compose([
    ])
  };
  carLoanOriginationCheck = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanOriginationFee = {
    value: null,
    validation: Validators.compose([
      Validators.max(1210)
    ])
  };
  carLoanSubtotalAndFees = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanBrokerCheck = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanBrokeragePercent = {
    value: null,
    validation: Validators.compose([])
  };
  carLoanBrokerageAmount = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanTotalAmount = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanRepaymentFrequency = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanTerm = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanBalloonAmount = {
    value: null,
    validation: Validators.compose([
    ])
  };
  carLoanBalloonPercent = {
    value: null,
    validation: Validators.compose([
    ])
  };
}
